<template>
    <div class="checkbox checkbox__early-delivery">
        <label>
            <input
                name="early-invoice"
                type="checkbox"
                :value="earlyInvoice"
                :checked="earlyInvoice"
                @change="updateEarlyInvoice"
            >
            <span class="custom-checkbox"/>
            <span v-html="text"/>
        </label>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        text: {
            type: String,
            default: 'Wir möchten unsere Bestellung vor 10 Uhr morgens erhalten.<br>Der Aufpreis für die Öpfelchasper-Frühlieferung beträgt 5 CHF pro Lieferung.',
        },
    },
    computed: {
        ...mapState({
            mode: state => state.mode,
            earlyInvoice: state => state.earlyInvoice,
        }),
    },
    methods: {
        updateEarlyInvoice() {
            this.$store.commit('updateEarlyInvoice');
        },
    },
};
</script>



// WEBPACK FOOTER //
// EarlyInvoice.vue?55fb8274